// Client API minimal (fetch + cookie de sesiune httpOnly).
// Mesajele de eroare vin din backend — nu afișăm niciodată detalii tehnice brute.
// În producție API-ul e pe același domeniu (proxied de Apache /api → 127.0.0.1:4000);
// în dev .env setează REACT_APP_API_URL=http://localhost:4000.
export const API_BASE = process.env.REACT_APP_API_URL || "";

async function apiFetch(path, options = {}) {
  let res;
  try {
    const esteFormData = options.body instanceof FormData;
    res = await fetch(`${API_BASE}${path}`, {
      credentials: "include",
      // FormData își setează singur Content-Type cu boundary
      headers: esteFormData ? { ...(options.headers || {}) } : { "Content-Type": "application/json", ...(options.headers || {}) },
      ...options,
    });
  } catch {
    // rețea indisponibilă / fetch absent (teste) — mesaj sigur pentru utilizator
    const err = new Error("Serviciul nu este disponibil. Verifică conexiunea.");
    err.status = 0;
    throw err;
  }

  let body = null;
  try {
    body = await res.json();
  } catch {
    // răspuns fără corp JSON
  }

  if (!res.ok) {
    if (res.status === 401) {
      // Sesiuune expirată/invalidă → AuthContext resetează starea și trimite la /login
      window.dispatchEvent(new Event("auth:unauthorized"));
    }
    const err = new Error(body?.error || "Eroare de rețea");
    err.status = res.status;
    err.detalii = body?.detalii || null;
    throw err;
  }
  return body;
}

export const api = {
  get: (path) => apiFetch(path),
  post: (path, data) => apiFetch(path, { method: "POST", body: data instanceof FormData ? data : JSON.stringify(data ?? {}) }),
  patch: (path, data) => apiFetch(path, { method: "PATCH", body: data instanceof FormData ? data : JSON.stringify(data) }),
  put: (path, data) => apiFetch(path, { method: "PUT", body: data instanceof FormData ? data : JSON.stringify(data) }),
  delete: (path) => apiFetch(path, { method: "DELETE" }),
};
